export class ListSelectedModel {
  public selectedIdMap: Map<string, boolean>;

  constructor() {
    this.selectedIdMap = new Map<string, boolean>();
  }
}
